export const sanitizeError = (error) => {
  // Development'da tam error, production'da generic
  if (process.env.NODE_ENV === 'development') {
    return error.message || 'Bir hata oluştu';
  }
  
  // Production'da generic mesajlar
  const genericMessages = {
    'duplicate key': 'Bu kayıt zaten mevcut',
    'foreign key': 'İlişkili veri bulunamadı',
    'not null': 'Zorunlu alan boş bırakılamaz',
    'permission denied': 'Bu işlem için yetkiniz yok',
    'rate limit': 'Çok fazla istek gönderdiniz, lütfen bekleyin',
    'invalid credentials': 'Geçersiz kimlik bilgileri',
    'email already registered': 'Bu e-posta adresi zaten kayıtlı',
    'weak password': 'Şifre çok zayıf',
    'invalid email': 'Geçersiz e-posta adresi'
  };
  
  const errorMsg = error.message?.toLowerCase() || '';
  
  for (const [key, message] of Object.entries(genericMessages)) {
    if (errorMsg.includes(key)) {
      return message;
    }
  }
  
  return 'İşlem sırasında bir hata oluştu';
};
